import { useHistory, useLocation } from "react-router-dom";

// strona wyników w query (?page=2, w URL od 1); zmiana filtrów (filtersToSearch) przepisuje query bez page → reset do 0
export function useSearchPage() {
	const location = useLocation();
	const history = useHistory();
	const params = new URLSearchParams(location.search);
	const page = Math.max(Number(params.get("page")) - 1 || 0, 0);

	const setPage = (next: number) => {
		const nextParams = new URLSearchParams(location.search);
		if (next > 0) nextParams.set("page", String(next + 1));
		else nextParams.delete("page");
		history.replace({
			pathname: location.pathname,
			search: nextParams.toString(),
			state: location.state,
		});
	};

	return [page, setPage] as const;
}
